const Spacing = {
  XXS: 4,
  XS: 8,
  S: 16,
  M: 24,
  L: 32,
  XL: 48,
  XXL: 64,
}

export default Spacing
